export default "__VITE_ASSET__DL_YVZVK__"